import VMasker from 'vanilla-masker';
import * as constants from '../constant';
// DW-0963: reuso do validador-ouro alfanumérico (sem drift).
import { cnpjValido, somenteAlfanumerico } from '../validationSchemas';
import _reduce from 'lodash/reduce';
import axios from 'axios';
import { toast } from 'react-toastify';
import LocalStorage from '~/Utils/LocalStorage';
import moment from 'moment';
import * as api from '~/Services/Service';
require('moment/locale/pt-br');
moment.locale('pt-br');

export const serialize = function(obj) {
  var str = [];
  for (let p in obj)
    if (obj.hasOwnProperty(p) && obj[p]) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  return str.join('&');
};
export const BASE_IMG_URL =
  'https://repositorio.setcorp.com.br/imagens/icones/svg/';
/**
 *
 * @param {*} str
 * @returns Object
 */
export const unserialize = str => {
  if (!str) return {};

  return str
    .replace(/(^\?)/, '')
    .split('&')
    .reduce((prev, curr) => {
      curr = curr.split('=');
      return {
        ...prev,
        [decodeURIComponent(curr[0])]: decodeURIComponent(curr[1]),
      };
    }, {});
};
export const mask = {
  phone: phone => {
    return constants.MASK_CEL;
  },
  celular: phone => {
    if (!phone) {
      return constants.MASK_CEL;
    }

    let numbers = phone.replace(/\s|-|_|\.|\(|\)/g, '');
    let numberLength = 0;
    if (numbers) {
      numberLength = numbers.length;
    }

    return numberLength > 10 ? constants.MASK_CEL_11 : constants.MASK_CEL_10;
  },
  cpf_cnpj: str => {
    if (!str) {
      return constants.MASK_CPF;
    }

    // DW-0963: decide CPF x CNPJ por caracteres ALFANUMÉRICOS (não só dígitos).
    // Qualquer letra OU comprimento > 11 → máscara alfanumérica (evita strip de letra ao digitar).
    const texto = String(str);
    const alfanumerico = texto.toUpperCase().replace(/[^A-Z0-9]/g, '');

    if (!alfanumerico) {
      return constants.MASK_CPF;
    }

    return /[A-Z]/.test(alfanumerico) || alfanumerico.length > 11
      ? constants.MASK_CNPJ_ALFANUMERICO
      : constants.MASK_CPF;
  },
  monetario: value => {
    const d = /\d/;
    const numbers = (value || '').replace(/\D/g, '');
    const intLen = Math.max(numbers.length - 2, 1);

    const mask = ['R', '$', ' '];
    for (let i = 0; i < intLen; i++) {
      if (i > 0 && (intLen - i) % 3 === 0) {
        mask.push('.');
      }
      mask.push(d);
    }
    mask.push(',', d, d);

    return mask;
  },
};

export const MIN_SQL_DATE = new Date(1753, 1, 1);

export const cloneDate = date => moment(date);
export const createDate = (string, format = constants.DATE_FORMAT_SERVER) =>
  moment(string, format);
export const getToday = () => moment();

export const format = {
  phone: value => {
    if (!value) {
      return '';
    }
    value = value.match(/\d/g);

    return value ? VMasker.toPattern(value, '(99) 9999-9999') : '';
  },
  cpf: value => {
    if (!value) {
      return '';
    }

    const alfanumerico = String(value).toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (!alfanumerico) {
      return '';
    }

    if (/[A-Z]/.test(alfanumerico) || alfanumerico.length > 11) {
      const cnpj = alfanumerico.substring(0, 14);
      if (cnpj.length <= 2) return cnpj;
      if (cnpj.length <= 5) return `${cnpj.substring(0, 2)}.${cnpj.substring(2)}`;
      if (cnpj.length <= 8) {
        return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5)}`;
      }
      if (cnpj.length <= 12) {
        return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5, 8)}/${cnpj.substring(8)}`;
      }
      return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5, 8)}/${cnpj.substring(8, 12)}-${cnpj.substring(12)}`;
    }

    return VMasker.toPattern(alfanumerico, '999.999.999-99');
  },
  cep: value => {
    if (!value) {
      return '';
    }
    value = value.match(/\d/g);

    return value ? VMasker.toPattern(value, '99999-999') : '';
  },
  celular: value => {
    if (!value) {
      return '';
    }

    value = value.match(/\d/g);
    if (value.length > 10) {
      return value ? VMasker.toPattern(value, '(99) 99999-9999') : '';
    } else {
      return value ? VMasker.toPattern(value, '(99) 9999-9999') : '';
    }
  },
  date: (string, format = constants.DATE_DEFAULT_FORMAT) => {
    return createDate(string).format(format);
  },
  datetime: (string, format = constants.DATETIME_DEFAULT_FORMAT) => {
    return createDate(string).format(format);
  },
  timestamp: (string, format = constants.DATE_FORMAT_SERVER) => {
    return createDate(string, format).unix();
  },
  clear: str => {
    if (!str) return '';
    return str.replace(/[^0-9]+/g, '');
  },
};

export const bancos = [
  {
    value: '001',
    name: 'Banco do Brasil',
  },
  {
    value: '003',
    name: 'Banco da Amazônia',
  },
  {
    value: '004',
    name: 'Banco do Nordeste',
  },
  {
    value: '021',
    name: 'Banestes',
  },
  {
    value: '025',
    name: 'Banco Alfa',
  },
  {
    value: '027',
    name: 'Besc',
  },
  {
    value: '029',
    name: 'Banerj',
  },
  {
    value: '031',
    name: 'Banco Beg',
  },
  {
    value: '033',
    name: 'Banco Santander Banespa',
  },
  {
    value: '036',
    name: 'Banco Bem',
  },
  {
    value: '037',
    name: 'Banpará',
  },
  {
    value: '038',
    name: 'Banestado',
  },
  {
    value: '039',
    name: 'BEP',
  },
  {
    value: '040',
    name: 'Banco Cargill',
  },
  {
    value: '041',
    name: 'Banrisul',
  },
  {
    value: '044',
    name: 'BVA',
  },
  {
    value: '045',
    name: 'Banco Opportunity',
  },
  {
    value: '047',
    name: 'Banese',
  },
  {
    value: '062',
    name: 'Hipercard',
  },
  {
    value: '063',
    name: 'Ibibank',
  },
  {
    value: '065',
    name: 'Lemon Bank',
  },
  {
    value: '066',
    name: 'Banco Morgan Stanley Dean Witter',
  },
  {
    value: '069',
    name: 'BPN Brasil',
  },
  {
    value: '070',
    name: 'Banco de Brasília – BRB',
  },
  {
    value: '072',
    name: 'Banco Rural',
  },
  {
    value: '073',
    name: 'Banco Popular',
  },
  {
    value: '074',
    name: 'Banco J. Safra',
  },
  {
    value: '075',
    name: 'Banco CR2',
  },
  {
    value: '076',
    name: 'Banco KDB',
  },
  {
    value: '077',
    name: 'Banco Inter',
  },
  {
    value: '096',
    name: 'Banco BMF',
  },
  {
    value: '104',
    name: 'Caixa Econômica Federal',
  },
  {
    value: '107',
    name: 'Banco BBM',
  },
  {
    value: '116',
    name: 'Banco Único',
  },
  {
    value: '151',
    name: 'Nossa Caixa',
  },
  {
    value: '175',
    name: 'Banco Finasa',
  },
  {
    value: '184',
    name: 'Banco Itaú BBA',
  },
  {
    value: '204',
    name: 'American Express Bank',
  },
  {
    value: '208',
    name: 'Banco Pactual',
  },
  {
    value: '212',
    name: 'Banco Matone',
  },
  {
    value: '213',
    name: 'Banco Arbi',
  },
  {
    value: '214',
    name: 'Banco Dibens',
  },
  {
    value: '217',
    name: 'Banco Joh Deere',
  },
  {
    value: '218',
    name: 'Banco Bonsucesso',
  },
  {
    value: '222',
    name: 'Banco Calyon Brasil',
  },
  {
    value: '224',
    name: 'Banco Fibra',
  },
  {
    value: '225',
    name: 'Banco Brascan',
  },
  {
    value: '229',
    name: 'Banco Cruzeiro',
  },
  {
    value: '230',
    name: 'Unicard',
  },
  {
    value: '233',
    name: 'Banco GE Capital',
  },
  {
    value: '237',
    name: 'Bradesco',
  },
  {
    value: '237',
    name: 'Next',
  },
  {
    value: '241',
    name: 'Banco Clássico',
  },
  {
    value: '243',
    name: 'Banco Stock Máxima',
  },
  {
    value: '246',
    name: 'Banco ABC Brasil',
  },
  {
    value: '248',
    name: 'Banco Boavista Interatlântico',
  },
  {
    value: '249',
    name: 'Investcred Unibanco',
  },
  {
    value: '250',
    name: 'Banco Schahin',
  },
  {
    value: '252',
    name: 'Fininvest',
  },
  {
    value: '254',
    name: 'Paraná Banco',
  },
  {
    value: '263',
    name: 'Banco Cacique',
  },
  {
    value: '260',
    name: 'Nubank',
  },
  {
    value: '265',
    name: 'Banco Fator',
  },
  {
    value: '266',
    name: 'Banco Cédula',
  },
  {
    value: '300',
    name: 'Banco de la Nación Argentina',
  },
  {
    value: '318',
    name: 'Banco BMG',
  },
  {
    value: '320',
    name: 'Banco Industrial e Comercial',
  },
  {
    value: '356',
    name: 'ABN Amro Real',
  },
  {
    value: '341',
    name: 'Itau',
  },
  {
    value: '347',
    name: 'Sudameris',
  },
  {
    value: '351',
    name: 'Banco Santander',
  },
  {
    value: '353',
    name: 'Banco Santander Brasil',
  },
  {
    value: '366',
    name: 'Banco Societe Generale Brasil',
  },
  {
    value: '370',
    name: 'Banco WestLB',
  },
  {
    value: '376',
    name: 'JP Morgan',
  },
  {
    value: '389',
    name: 'Banco Mercantil do Brasil',
  },
  {
    value: '394',
    name: 'Banco Mercantil de Crédito',
  },
  {
    value: '399',
    name: 'HSBC',
  },
  {
    value: '409',
    name: 'Unibanco',
  },
  {
    value: '412',
    name: 'Banco Capital',
  },
  {
    value: '422',
    name: 'Banco Safra',
  },
  {
    value: '453',
    name: 'Banco Rural',
  },
  {
    value: '456',
    name: 'Banco Tokyo Mitsubishi UFJ',
  },
  {
    value: '464',
    name: 'Banco Sumitomo Mitsui Brasileiro',
  },
  {
    value: '477',
    name: 'Citibank',
  },
  {
    value: '479',
    name: 'Itaubank (antigo Bank Boston)',
  },
  {
    value: '487',
    name: 'Deutsche Bank',
  },
  {
    value: '488',
    name: 'Banco Morgan Guaranty',
  },
  {
    value: '492',
    name: 'Banco NMB Postbank',
  },
  {
    value: '494',
    name: 'Banco la República Oriental del Uruguay',
  },
  {
    value: '495',
    name: 'Banco La Provincia de Buenos Aires',
  },
  {
    value: '505',
    name: 'Banco Credit Suisse',
  },
  {
    value: '600',
    name: 'Banco Luso Brasileiro',
  },
  {
    value: '604',
    name: 'Banco Industrial',
  },
  {
    value: '610',
    name: 'Banco VR',
  },
  {
    value: '611',
    name: 'Banco Paulista',
  },
  {
    value: '612',
    name: 'Banco Guanabara',
  },
  {
    value: '613',
    name: 'Banco Pecunia',
  },
  {
    value: '623',
    name: 'Banco Panamericano',
  },
  {
    value: '626',
    name: 'Banco Ficsa',
  },
  {
    value: '630',
    name: 'Banco Intercap',
  },
  {
    value: '633',
    name: 'Banco Rendimento',
  },
  {
    value: '634',
    name: 'Banco Triângulo',
  },
  {
    value: '637',
    name: 'Banco Sofisa',
  },
  {
    value: '638',
    name: 'Banco Prosper',
  },
  {
    value: '643',
    name: 'Banco Pine',
  },
  {
    value: '652',
    name: 'Itaú Holding Financeira',
  },
  {
    value: '653',
    name: 'Banco Indusval',
  },
  {
    value: '654',
    name: 'Banco A.J. Renner',
  },
  {
    value: '655',
    name: 'Banco Votorantim',
  },
  {
    value: '707',
    name: 'Banco Daycoval',
  },
  {
    value: '719',
    name: 'Banif',
  },
  {
    value: '721',
    name: 'Banco Credibel',
  },
  {
    value: '734',
    name: 'Banco Gerdau',
  },
  {
    value: '735',
    name: 'Banco Neon',
  },
  {
    value: '738',
    name: 'Banco Morada',
  },
  {
    value: '739',
    name: 'Banco Galvão de Negócios',
  },
  {
    value: '740',
    name: 'Banco Barclays',
  },
  {
    value: '741',
    name: 'BRP',
  },
  {
    value: '743',
    name: 'Banco Semear',
  },
  {
    value: '745',
    name: 'Banco Citibank',
  },
  {
    value: '746',
    name: 'Banco Modal',
  },
  {
    value: '747',
    name: 'Banco Rabobank International',
  },
  {
    value: '748',
    name: 'Banco Cooperativo Sicredi',
  },
  {
    value: '749',
    name: 'Banco Simples',
  },
  {
    value: '751',
    name: 'Dresdner Bank',
  },
  {
    value: '752',
    name: 'BNP Paribas',
  },
  {
    value: '753',
    name: 'Banco Comercial Uruguai',
  },
  {
    value: '755',
    name: 'Banco Merrill Lynch',
  },
  {
    value: '756',
    name: 'Banco Cooperativo do Brasil',
  },
  {
    value: '757',
    name: 'KEB',
  },
];

export const capitalize = str => {
  if (!str) {
    return str;
  }

  return (
    str &&
    str
      .split(' ')
      .map(item => {
        item = item.toLowerCase().split('');
        if (item[0]) {
          item[0] = item[0].toUpperCase();
        }
        return item.join('');
      })
      .join(' ')
  );
};

//Altera os valores null das propriedades de um objeto para string vazia
export const nullPropertiesToString = obj =>
  _reduce(
    obj,
    (result, value, key) => {
      result[key] = value === null ? '' : value;
      return result;
    },
    {}
  );

export const CapitalizarTexto = sentence => {
  const palavra = sentence.split(' ');
  const palavrasCapitalizadas = palavra.map(p => {
    return p.charAt(0).toUpperCase() + p.slice(1);
  });
  return palavrasCapitalizadas.join(' ');
};

export const formatarComZero = (mesa, length = 2) => {
  let str = '' + mesa;
  while (str.length < length) {
    str = '0' + str;
  }
  return str;
};

export const formatarMonetario = (
  valor,
  returnIfNoValue = true,
  prefix = 'R$ '
) => {
  if (!valor) {
    if (returnIfNoValue) return;
    else return `${prefix}0,00`;
  }
  valor = valor.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `${prefix}${valor}`;
};

export const strParaMonetario = (
  valor,
  returnIfNoValue = true,
  prefix = 'R$ '
) => {
  if (!valor && valor !== 0) {
    if (returnIfNoValue) return;
    else return `${prefix}0,00`;
  }

  const numero = typeof valor === 'string' ? parseFloat(valor) : Number(valor);

  const valorFormatado = numero.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `${prefix}${valorFormatado}`;
};

export const toTitleCase = str => {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const financeiro = {
  price: {
    calcularValorFuturo: (valorAFinanciar, quantidadeParcelas, jurosPorMes) => {
      const valorParcela = this.calcularValorParcela(
        valorAFinanciar,
        quantidadeParcelas,
        jurosPorMes
      );
      return valorParcela * quantidadeParcelas;
    },
    calcularValorParcela: (
      valorAFinanciar,
      quantidadeParcelas,
      jurosPorMes
    ) => {
      if (jurosPorMes === 0 || jurosPorMes === -1)
        return valorAFinanciar / quantidadeParcelas;

      const pow = Math.pow(1.0 + jurosPorMes, quantidadeParcelas);
      const a = pow * jurosPorMes;
      const b = pow - 1.0;
      return (valorAFinanciar * a) / b;
    },
  },
};

export const contraSenhaHelper = {
  calcularDicaContraSenha: baseContraSenha => {
    const now = new Date();
    return baseContraSenha * now.getDate() * (now.getMonth() + 1);
  },
  calcularContraSenha: (totalSinal, baseContraSenha) => {
    return baseContraSenha * Math.floor(totalSinal);
  },
  calcularBaseContraSenha: (totalSinal, codigoBase) => {
    const now = new Date();
    let baseCS = 0;
    const cvalor = Math.floor(totalSinal).toString();

    for (const c of cvalor) baseCS += Number(c);

    baseCS += codigoBase + now.getFullYear() + now.getMonth() + now.getDate();
    while (baseCS > 15) {
      if (baseCS % 2 === 0) baseCS = Math.floor(baseCS / 2);
      else baseCS = Math.floor(baseCS / 3);
    }
    baseCS = Math.floor(baseCS);
    if (baseCS === 0) baseCS = 3;
    return Number(baseCS);
  },
};

export const downloadFileViaUrl = url => {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.click();
  a.remove();
};

export const openPopup = (url, nome, width, height, top, left) => {
  if (nome == '') nome = '';
  nome =
    typeof nome === 'undefined' ? new Date().getTime() : nome.replace(' ', '_');
  width =
    typeof width === 'undefined' ? window.screen.width - 150 : parseInt(width);
  height =
    typeof height === 'undefined'
      ? window.screen.height - 150
      : parseInt(height);
  top =
    typeof top === 'undefined'
      ? window.screen.height / 2 - height / 2
      : parseInt(top);
  left =
    typeof left === 'undefined'
      ? window.screen.width / 2 - width / 2
      : parseInt(left);
  var top, left;
  var closed = true;
  try {
    closed = window['popup_' + nome].closed;
  } catch (ex) {}
  if (typeof window['popup_' + nome] === 'undefined' || closed) {
    try {
      window['popup_' + nome] = window.open(
        url,
        nome,
        'scrollbars=1, menubar=0, resizable=0, directories=0, location=0, toolbar=0, status=0, top=' +
          top +
          ', left=' +
          left +
          ', width=' +
          width +
          ', height=' +
          height
      );
    } catch (ex) {
      delete window['popup_' + nome];
    }
  } else window['popup_' + nome].location.href = url;
  if (typeof window['popup_' + nome] === 'undefined')
    alert(
      'O link n\u00e3o p\u00f4de ser aberto.\nPor favor, verifique se o bloqueador de pop-ups est\u00e1 ativado.'
    );
  else window['popup_' + nome].focus();
};

export const salvarEmExcel = async (dados, urlEp, nomePadrao) => {
  try {
    const request = dados;

    let token = LocalStorage.get(constants.AUTH_KEY)
      ? 'Bearer ' + LocalStorage.get(constants.AUTH_KEY)
      : null;

    const response = await axios.post(constants.APIBASE + urlEp, request, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      responseType: 'blob',
    });
    if (response) {
      // O header content-disposition pode não vir (backend não envia ou não
      // está exposto via CORS). Trata a ausência para não quebrar com
      // "Cannot read properties of undefined (reading 'match')".
      let filename = nomePadrao || 'documento.xlsx';
      const header = response.headers['content-disposition'];
      if (header) {
        const match = header.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        }
      }
      const blob = new Blob([response.data], {
        type: 'application/octet-stream',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);
      link.remove();
    }
  } catch (error) {
    console.log(error.message);
    throw error;
  }
};

export const salvarEmPdf = async (urlEp, nomePadrao) => {
  try {
    let token = LocalStorage.get(constants.AUTH_KEY)
      ? 'Bearer ' + LocalStorage.get(constants.AUTH_KEY)
      : null;

    const response = await axios.get(constants.APIBASE + urlEp, {
      headers: {
        Authorization: token,
      },
      responseType: 'blob',
    });
    if (response) {
      let filename = nomePadrao || 'documento.pdf';
      const header = response.headers['content-disposition'];
      if (header) {
        const match = header.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        }
      }
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);
      link.remove();
    }
  } catch (error) {
    console.log(error.message);
    throw error;
  }
};

export const getInitial = (nome, somenteUmaLetra = false) => {
  if (!nome) return '?';

  if (somenteUmaLetra) {
    return nome.charAt(0).toUpperCase();
  }

  const partes = nome
    .trim()
    .split(' ')
    .filter(Boolean);
  const primeiraLetra = partes[0].charAt(0).toUpperCase();
  const ultimaLetra =
    partes.length > 1
      ? partes[partes.length - 1].charAt(0).toUpperCase()
      : primeiraLetra;

  return primeiraLetra + ultimaLetra;
};

export const validarCPF = value => {
  if (!value) return false;
  const cpf = value.replace(/\D/g, '');
  if (cpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;
  let soma = 0;
  let resto;
  for (let i = 1; i <= 9; i++)
    soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++)
    soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;
  return true;
};

export const validarCNPJ = value => {
  // DW-0963: delega ao validador-ouro alfanumérico (validationSchemas.cnpjValido):
  // valor por caractere = charCodeAt-48 (ASCII−48) + pesos módulo 11; 12 alfanuméricos + 2 DV numéricos.
  // Retrocompatível: CNPJ numérico legado valida idêntico.
  return cnpjValido(value);
};

export const validarCpfCnpj = value => {
  if (!value) return false;
  // DW-0963: CNPJ pode ser alfanumérico (14 posições). Decide por comprimento alfanumérico;
  // CPF permanece 11 dígitos numéricos.
  const alfanumerico = somenteAlfanumerico(value);
  if (alfanumerico.length === 14) return validarCNPJ(value);
  const digitos = value.replace(/\D/g, '');
  if (digitos.length === 11) return validarCPF(digitos);
  return false;
};

export const cleanCPF = cpf => {
  return cpf.replace(/\D/g, '');
};

export const cleanCpfCnpj = cpfCnpj => {
  if (!cpfCnpj) return '';
  const alfanumerico = somenteAlfanumerico(cpfCnpj);
  if (/[A-Z]/.test(alfanumerico) || alfanumerico.length > 11) return alfanumerico;
  return String(cpfCnpj).replace(/\D/g, '');
};

export const cleanTelefone = telefone => {
  return telefone.replace(/\D/g, '');
};

export const definirStatusComissao = (comissaoCancelada, comissaoBaixada) => {
  if (comissaoCancelada) {
    return 'Cancelada';
  }
  if (comissaoBaixada) {
    return 'Recebida';
  }
  return 'A receber';
};

// LICOES ciclo 9 L4 — helper padronizado de extração de mensagem de erro axios.
// O interceptor em Service.js já faz Promise.reject(error.response.data).
export const extrairMensagemErro = (
  err,
  fallback = 'Erro inesperado. Tente novamente.'
) => {
  if (!err) return fallback;
  if (typeof err === 'string') return err;
  if (err.message) return err.message;
  if (err.mensagem) return err.mensagem;
  if (err.Message) return err.Message;
  return fallback;
};

// Converte TColor (int BGR do Delphi) para hex CSS (#RRGGBB)
export const intToHexColor = val => {
  if (val === null || val === undefined) return undefined;
  const r = val & 0xff;
  const g = (val >> 8) & 0xff;
  const b = (val >> 16) & 0xff;
  return `#${r.toString(16).padStart(2, '0')}${g
    .toString(16)
    .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};

// W-0587 — helpers para Relatório de Cidades por Região

export const formatarCep = (cep) =>
  cep ? String(cep).padStart(8, '0').replace(/(\d{5})(\d{3})/, '$1-$2') : '';

export const formatarTimestamp = (dt) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${dt.getFullYear()}${pad(dt.getMonth() + 1)}${pad(dt.getDate())}-${pad(dt.getHours())}${pad(dt.getMinutes())}`;
};

// Geração de CSV client-side (sem dependência de biblioteca xlsx)
// Usa ponto-e-vírgula como separador (padrão pt-BR no Excel)
//
// Marca um valor para ser exportado como TEXTO literal no Excel. O Excel converte
// automaticamente strings no formato dd/mm/aaaa em data (número de série), exibindo
// `######` em colunas estreitas e podendo inverter dia/mês conforme o locale. Emitir
// a célula como ="valor" (fórmula de texto, avaliada pelo Excel ao abrir o CSV) força
// o valor a permanecer como texto, idêntico ao exibido na tela. Use apenas para
// conteúdo gerado pela própria aplicação (não para entrada de usuário).
export const textoExcel = (valor) => ({ __textoExcel: true, valor });

export const exportarEmExcel = (linhas, nomeArquivo) => {
  const conteudo = '﻿' + linhas
    .map((row) =>
      row.map((cell) => {
        if (cell != null && typeof cell === 'object' && cell.__textoExcel) {
          const t = cell.valor != null ? String(cell.valor) : '';
          return `="${t.replace(/"/g, '""')}"`;
        }
        const v = cell != null ? String(cell) : '';
        return v.includes(';') ||
          v.includes('"') ||
          v.includes('\n') ||
          v.includes('\r')
          ? `"${v.replace(/"/g, '""')}"`
          : v;
      }).join(';')
    )
    .join('\r\n');

  const blob = new Blob([conteudo], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeArquivo.replace(/\.xlsx?$/i, '.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// W-0608: dispara download de um blob (já retornado por httpService.fetch responseType:'blob').
// Diferente de `salvarEmExcel` que faz a request e o download juntos.
export const salvarPdf = (blob, nomeArquivo) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeArquivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// Aceita uma janela pré-aberta sincronamente no click handler (evita popup blocker
// depois do await). Quando `janelaPreAberta` é null/undefined, faz fallback pra window.open
// chamado aqui — pode ser bloqueado se chamado fora de gesto direto do usuário.
export const abrirPdfEmNovaAba = (blob, janelaPreAberta) => {
  const url = window.URL.createObjectURL(blob);
  const aba = janelaPreAberta || window.open('', '_blank');
  if (!aba) {
    window.URL.revokeObjectURL(url);
    return false;
  }
  aba.location.href = url;
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  return true;
};

// Rotas cujo endpoint gera o PDF em memória, armazena no cache (token) e
// devolve { url, nome_arquivo } com a URL final de visualização.
// Diferente de rotas que devolvem o PDF direto (binário) na resposta.
const ROTAS_PDF_VIA_TOKEN = [
  '/contratos/gerar-contrato-pdf/',
  '/contratos/gerar-proposta-pdf/',
  '/contratos/gerar-termo-ciencia-adesao-pdf/',
  '/contratos/gerar-carta-correcao-mensal-pdf/',
  '/contratos/gerar-declaracao-pagamento-pdf/',
  '/contratos/gerar-declaracao-imovel-caucionado-pdf/',
  '/contratos/gerar-declaracao-conjuge-pdf/',
  '/proposta/carta-iptu/',
  '/proposta/carta-isencao-iptu/',
  '/proposta/carta-uberaba-isencao-iptu/',
  '/proposta/declaracao-recebimento-boleto/',
  '/contratos/documento-digital-pdf/',
  '/contratos/documento-ativo-pdf/',
  '/contratos/mapa-calcadas-pdf/',
];

export const isRotaPdfViaToken = relativeUrl =>
  !!relativeUrl &&
  ROTAS_PDF_VIA_TOKEN.some(prefixo => relativeUrl.startsWith(prefixo));

export const abrirDocumentoTemporario = async relativeUrl => {
  const novaAba = window.open('', '_blank');
  if (!novaAba) {
    toast.error('Habilite pop-ups para visualizar o documento.');
    return;
  }
  try {
    const response = await api.gerarUrlDocumentoTemporario(relativeUrl);
    novaAba.location.href = response.url;
  } catch (err) {
    novaAba.close();
    const mensagem =
      err && err.message ? err.message : 'Erro ao gerar documento.';
    toast.error(mensagem);
  }
};
